import { type FirebaseOptions, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getRemoteConfig } from "firebase/remote-config";
import { getStorage } from "firebase/storage";

const projectConfigs: Record<string, { region: string; config: FirebaseOptions }> = {
    production: {
        region: "europe-west3",
        config: {
            apiKey: import.meta.env.VITE_FIREBASE_KEY_BINALE,
            authDomain: "binale-app-de.firebaseapp.com",
            databaseURL: "https://binale.europe-west1.firebasedatabase.app",
            projectId: "binale-app-de",
            storageBucket: "binale-app-de.appspot.com",
            messagingSenderId: "726144543922",
            appId: "1:726144543922:web:872fac9d7e01881fe0edab",
            measurementId: "G-2QHH5W6NMK",
        },
    },
    development: {
        region: "us-central1",
        config: {
            apiKey: "AIzaSyBcwTLsa8fZjRBBzWkv-zEapfXspuBGgj4",
            authDomain: "steuerflow-testing.firebaseapp.com",
            databaseURL: "https://steuerflow-testing.firebaseio.com",
            projectId: "steuerflow-testing",
            storageBucket: "steuerflow-testing.appspot.com",
            messagingSenderId: "560876633077",
            appId: "1:560876633077:web:2928c03806034194507ebc",
            measurementId: "G-NQYXGZ9H4H",
        },
    },
    dms: {
        region: "europe-west3",
        config: {
            apiKey: "AIzaSyCIBHFAmVFrDddxx5eBB5szJ0sBh0B3GpQ",
            authDomain: "binale-dms.firebaseapp.com",
            databaseURL: "https://binale-dms-default-rtdb.europe-west1.firebasedatabase.app",
            projectId: "binale-dms",
            storageBucket: "binale-dms.appspot.com",
            messagingSenderId: "211125218905",
            appId: "1:211125218905:web:41323d53ca63591d094b48",
            measurementId: "G-PL5BG73VZQ",
        },
    },
};

const getConfig = (): (typeof projectConfigs)[string] => {
    if (import.meta.env.VITE_PRODUCTION_DATABASE) {
        return projectConfigs.production;
    }
    if (import.meta.env.VITE_FIREBASE_ENV) {
        const key = import.meta.env.VITE_FIREBASE_ENV;
        if (!projectConfigs[key]) {
            throw new Error(`Config from env "${key}" is not defined`);
        }
        return projectConfigs[key];
    }
    return projectConfigs.development;
};

const firebaseApp = initializeApp(getConfig().config);
export const database = getDatabase(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const remoteConfig = getRemoteConfig(firebaseApp);
/**
 * App Check is not initialised.
 *
 * It was, with `ReCaptchaEnterpriseProvider` at module scope - so every page load,
 * before any sign-in and on the public pages too, pulled
 * `google.com/recaptcha/enterprise.js`, wrote a token into IndexedDB and let Google
 * evaluate device and behaviour signals. The backend never verified the token
 * (`validateFirebaseIdToken` checks only the Firebase ID token), so it bought no
 * protection at all while adding a third-party request, a device-signal
 * transmission and a disclosure obligation.
 *
 * The plumbing below stays so that turning it back on is a one-function change:
 * callers already send the header, and `getAppCheckToken` keeps its signature and
 * returns an empty string. **Re-enabling it means enforcing verification on the
 * backend first, and adding it back to the Datenschutzerklärung § 6 storage table
 * and the § 8.1 Google entry - it is terminal-device access under § 25 TDDDG and a
 * transfer to Google.**
 */
export const getAppCheckToken = async () => "";

export function encodeKey(s: string) {
    return s.replace(/\./g, "%2E");
}

export function decodeKey(s: string) {
    return s.replace(/%2E/g, ".");
}
